import React from 'react';
import { withPrefix } from 'gatsby';

export const MosaicBg = ({
    gradientDirection,
    gradientAngle = '90deg',
    gradientEnd = '100%',
    opacity = 1
}) => {
    return (
        <div className="tw-w-full tw-h-full tw-overflow-hidden tw-absolute tw-left-0 tw-top-0 tw-flex tw-items-center">
            <div className="tw-relative tw-w-full tw-h-full">
                <div
                    className="tw-w-full tw-h-full tw-absolute tw-left-0 tw-top-0 tw-bg-cover"
                    style={{
                        backgroundImage: `url(${withPrefix('/images/svg/deco/mosaic.inline.svg')})`
                    }}
                />
                <div
                    className="tw-w-full tw-h-full tw-absolute tw-left-0 tw-top-0"
                    style={{
                        background:
                            gradientDirection === 'toLeft'
                                ? `linear-gradient(${gradientAngle},  rgba(13, 13, 106, 0) 0%, rgba(0, 0, 0, ${opacity}) ${gradientEnd})`
                                : `linear-gradient(${gradientAngle}, rgba(0, 0, 0, ${opacity}) 0%, rgba(13, 13, 106, 0) ${gradientEnd})`
                    }}
                />
            </div>
        </div>
    );
};
